import axiosInstance from "@/api/axios-instance";

// ADHD assessment care-team bridge (template/adhd-assessment-product.md §5.3).

// TODO(adhd-launch): extend once clinical finalises the outcome vocabulary.
export const ASSESSMENT_OUTCOMES = [
  { value: "SIGNS_INDICATED", label: "Signs indicate condition" },
  { value: "NOT_INDICATED", label: "Signs do not indicate condition" },
] as const;

export const DIVA_OUTCOMES = [
  { value: "ADHD_CONFIRMED", label: "Meets DSM-5 criteria for ADHD" },
  { value: "NOT_INDICATED", label: "ADHD not indicated" },
] as const;

// IPDE (Personality Disorder Care) diagnostic outcomes — the values the IPDE
// parser writes and the report page keys its variants on. NOT_INDICATED is
// shared with DIVA.
export const IPDE_OUTCOMES = [
  { value: "PD_INDICATED", label: "Personality disorder indicated" },
  { value: "NOT_INDICATED", label: "Not indicated" },
] as const;

export interface DivaScores {
  attention_childhood?: number;
  attention_adulthood?: number;
  hyperactivity_childhood?: number;
  hyperactivity_adulthood?: number;
}

export async function updateUsageMetadata(
  usage_id: string,
  data: {
    assessment_outcome?: string;
    assessment_notes?: string;
    diva_outcome?: string;
    diva_scores?: DivaScores;
  }
) {
  const response = await axiosInstance.patch(
    `/usage/${usage_id}/metadata`,
    data
  );
  return response.data;
}

export async function parseDivaReport(usage_id: string) {
  const response = await axiosInstance.post(`/diva-report/${usage_id}/parse`);
  return response.data;
}

export interface ReparseResult {
  success: boolean;
  parsed: {
    diva_outcome: string | null;
    severity: string | null;
    diva_scores: DivaScores;
  };
}

// Re-run the PDF parse on the saved report and refresh the stored result.
export async function reparseDivaReport(
  usage_id: string
): Promise<ReparseResult> {
  const response = await axiosInstance.post(
    `/diva-report/${usage_id}/reparse`
  );
  return response.data;
}

// Care-team preview of the saved report PDF (blob for an object URL).
export async function fetchDivaReportPdf(usage_id: string): Promise<Blob> {
  const response = await axiosInstance.get(`/diva-report/${usage_id}/view`, {
    responseType: "blob",
  });
  return response.data;
}

export async function saveDivaReport(usage_id: string, file: File) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosInstance.post(
    `/diva-report/${usage_id}/save`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
}
